import Box from "@mui/material/Box";
import { useTheme } from "@mui/material/styles";

import SectionWrapper from "./SectionWrapper";
import React from "react";

export default function Divider() {
  const theme = useTheme();

  return (
    <SectionWrapper>
      <Box
        sx={{
          width: "100%",
          borderTop: `2px solid ${theme.palette.grey[300]}`,
        }}
      />
    </SectionWrapper>
  );
}
